// extracted by mini-css-extract-plugin
export default {"root":"DragTooltip_root__tfYCy","show":"DragTooltip_show__Jcz+s","image":"DragTooltip_image__X7jp2"};